// PRODUCT-IA-CLEANUP-001A: extracted from the (now removed) historical
// pro-editorial workspace's `proEditorialUtils.js` — these two pure,
// dependency-free helpers are shared with the canonical
// `MasterContentDetail` component and must survive that removal.
//
// Minimal, dependency-free "safe" Markdown -> React node renderer.
// Never uses dangerouslySetInnerHTML: every emitted node is either a plain
// text string (React escapes it automatically) or a React element built
// from a whitelisted, hardcoded tag — there is no way for body_markdown
// content to inject raw HTML. Supports only the inline syntax realistic for
// long-form editorial prose: **bold**, *italic*/_italic_, and paragraph
// breaks on blank lines. Anything else (unsupported syntax) is rendered as
// literal text, never as HTML.

const INLINE_TOKEN_RE = /(\*\*([^*]+)\*\*|\*([^*]+)\*|_([^_]+)_)/g;

export function parseInlineMarkdown(text) {
  const nodes = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  INLINE_TOKEN_RE.lastIndex = 0;
  while ((match = INLINE_TOKEN_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    if (match[2] !== undefined) {
      nodes.push({ type: 'bold', text: match[2], key: `b${key++}` });
    } else {
      const italicText = match[3] !== undefined ? match[3] : match[4];
      nodes.push({ type: 'italic', text: italicText, key: `i${key++}` });
    }
    lastIndex = INLINE_TOKEN_RE.lastIndex;
  }
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }
  return nodes;
}

export function splitMarkdownParagraphs(bodyMarkdown) {
  return (bodyMarkdown || '')
    .split(/\n\s*\n/)
    .map(block => block.trim())
    .filter(Boolean);
}
